<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>アイコン</title-bar>
    <!-- <setting-nav></setting-nav> -->
    <b-form>
      <b-form-group :id="'miniicon'+icon.value" v-for="(icon, index) in form" :key="icon.value">
        {{index+1}}:<b-form-input v-model="icon.url" debounce="500"></b-form-input>
        <b-img width="60px" height="60px" :src="icon.url" fluid></b-img>
      </b-form-group>
      <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
      <response-message :value="postMessage" />
    </b-form>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import ResponseMessage from '@/components/ResponseMessage'
// import SettingNav from '@/components/SettingNav'
export default {
  components: {
    WhitePage,
    TitleBar,
    ResponseMessage,
    // SettingNav
  },
  data () {
    return {
      form: [],
      loading: false,
      postMessage: {}
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
        this.form = response.list
    },
    onSubmit () {
      this.$store.dispatch('setMiniIcon', this.form)
        .then((response)=>{
          this.postMessage = response
        })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getMiniIcon')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  // mounted () {
  //   phina.global.app.currentScene.exit('MainScene')
  // }
}
</script>

<style lang="scss" scoped>
</style>
